import { InjectionToken } from '@angular/core';

export const TRANSLATION_FILES = new InjectionToken<string[]>('TRANSLATION_FILES');
